module.exports = "/images/immersions.svg?a6a7bfcaf7e191c3ab0257dcb7e8fdc3";